import React from 'react';
const CART_URL = 'https://www.tusoluciondigital.shop/cart/43130152714306:1';
export function BonusSection() {
  return <section className="bg-purple-900 text-white py-12 md:py-16 px-4" data-id="element-47">
      <div className="max-w-5xl mx-auto" data-id="element-48">
        <h2 className="text-3xl md:text-4xl font-black mb-4 text-center" data-id="element-49">
          🎁 BONOS ESPECIALES – GRATIS HOY
        </h2>
        <p className="text-xl text-center mb-10 text-yellow-300 font-bold" data-id="element-50">
          ¡Estos bonos son GRATIS solo por el día de hoy!
        </p>

        <div className="grid md:grid-cols-2 gap-8 mb-10" data-id="element-51">
          <div className="bg-white text-gray-900 rounded-lg overflow-hidden shadow-2xl" data-id="element-52">
            <a href={CART_URL} className="block hover:opacity-90 transition-opacity" data-id="element-53">
              <img src="https://cdn.magicpatterns.com/uploads/6Fk2t3ot9qEwSikow8Wafj/imagen_2.png" alt="Protocolo Anti-Recaída" className="w-full aspect-square object-cover" data-id="element-54" />
            </a>
            <div className="p-6" data-id="element-55">
              <h3 className="text-2xl font-black mb-3" data-id="element-56">
                🎁 Bono #1 – "PROTOCOLO" ANTI-RECAIDA
              </h3>
              <p className="text-lg font-semibold mb-4" data-id="element-57">
                Qué hacer EXACTAMENTE cuando volvés a pensar en él?
              </p>
              <p className="text-gray-700 mb-4" data-id="element-58">
                Un sistema práctico con ejercicios para frenar el pensamiento
                obsesivo en el momento exacto.
              </p>
              <ul className="space-y-2 text-gray-700 mb-4" data-id="element-59">
                <li data-id="element-60">✔ Cómo controlar el impulso de escribirle</li>
                <li data-id="element-61">✔ Qué hacer cuando querés stalkearlo</li>
                <li data-id="element-62">✔ Ejercicios para no perder el enfoque en vos</li>
                <li data-id="element-63">✔ Espacios para que puedas escribir tus reflexiones</li>
              </ul>
              <p className="text-gray-500 line-through text-lg" data-id="element-64">
                Valor: $9.999
              </p>
              <p className="text-red-600 font-black text-2xl" data-id="element-65">🔥 HOY: GRATIS</p>
            </div>
          </div>

          <div className="bg-white text-gray-900 rounded-lg overflow-hidden shadow-2xl" data-id="element-66">
            <a href={CART_URL} className="block hover:opacity-90 transition-opacity" data-id="element-67">
              <img src="https://cdn.magicpatterns.com/uploads/4eJDdbS1pmtUzWgQm9UTpd/imagen_3.png" alt="De Migajas al Amor Propio" className="w-full aspect-square object-cover" data-id="element-68" />
            </a>
            <div className="p-6" data-id="element-69">
              <h3 className="text-2xl font-black mb-3" data-id="element-70">
                🎁 Bono #2 – "DE MIGAJAS AL AMOR PROPIO"
              </h3>
              <p className="text-lg font-semibold mb-4" data-id="element-71">
                No aceptes menos de lo que te merecés
              </p>
              <p className="text-gray-700 mb-4" data-id="element-72">
                El ebook final para transformarte en la mujer que QUERES SER.
              </p>
              <ul className="space-y-2 text-gray-700 mb-4" data-id="element-73">
                <li data-id="element-74">✔ Cómo dejar de aceptar migajas emocionales</li>
                <li data-id="element-75">✔ Subir tus estándares sin culpa</li>
                <li data-id="element-76">
                  ✔ Elegirte sin que nadie te haga dudar de tus decisiones
                </li>
                <li data-id="element-77">✔ Transformacion</li>
              </ul>
              <p className="text-gray-500 line-through text-lg" data-id="element-78">
                Valor: $12.999
              </p>
              <p className="text-red-600 font-black text-2xl" data-id="element-79">🔥 HOY: GRATIS</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}